<template>
  <div class="home">
    <div class="title">
      <h3>Logga in</h3>
    </div>

    <div class="error" v-if="hasError">{{ errorMessages[error] }}</div>

    <div style="font-size:13px;margin-top:20px;">
      <div style="padding:20px;padding-top:5px;">
          <div style="margin-bottom:15px;font-size:14px;text-align:center;">By signing in, you are authorizing <u>{{ clientIdName }}</u> to control your devices.</div>

        <div><input class="input" type="email" placeholder="E-post" v-model="email"></div>
        <div><input class="input" type="password" placeholder="Lösenord" v-model="password"></div>
        <div style="text-align:center;"><button class="submit" :disabled="!ok" @click="login">{{ loading ? 'Laddar...' :
            'Logga in' }}</button></div>
      </div>
    </div>
  </div>
</template>

<style>
.home {
  margin:12px;
}
</style>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'GoogleLogin',
  metaInfo: {
    title: 'System Nexa 2 – Login'
  },
  components: {},
  created () {
  },
  mounted () {
    //

  },
  data: () => ({
    email: '',
    password: '',
    token: '',
    error: '',
    errorMessages: {
      invalid_email_password: 'Ogiltlig e-post eller lösenord, försök igen!'
    },
    loading: false
  }),
  methods: {
    // login
    //
    //
    async login () {
      this.loading = true

      const response = await fetch('https://api.systemnexa2.se/1/account/login', {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: this.email,
          password: this.password
        })
      })

      const json = await response.json()
      if (json.success) {
        this.token = json.data.token

        this.success()
      }
      else {
        this.setError(json.message)
      }

      this.loading = false
    },

    // restore
    //
    //
    async success () {
      const query = this.$route.query

      const response = await fetch('https://api.systemnexa2.se/1/ga/login', {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          'x-token': this.token
        },
        body: JSON.stringify({
          client_id: query.client_id,
          redirect_uri: query.redirect_uri,
          response_type: query.response_type,
          state: query.state,
          login_token: this.token
        })
      })

      const json = await response.json()

      window.location = json.url
    },

    setError (error) {
      this.error = error

      setTimeout(() => {
        this.error = ''
      }, 3000)
    }
  },
  computed: {
    ok () {
      //return this.password.length >= 6 && (this.password === this.password2) && !this.loading
      return true
    },
    hasError () {
      return this.error.length > 0
    },

    clientId () {
      const clientId = this.$route.query?.client_id ?? ""
      return clientId
    },

    clientIdName () {
      if (this.clientId === 'google-assistant-nexa') return 'Google'
      return ''
    }
  }
}
</script>
